<template>
<transition :name="transition">
    <div v-show="this.visible">

        <!-- ii: {{ ii }}<br />
        index: {{ index }}<br />
        $parent.index: {{ $parent.index }}<br />
        visible: {{ visible }}<br /> -->
        <!-- diapo: {{ diapo }}<br />
        src: {{ src }}<br />
        src2: {{ src2 }}<br /> -->

        <slot>
            <img :src="src" style="width:100%" :alt="`diapo-${index + 1}`" />
        </slot>

    </div>
</transition>
</template>

<script>
export default {
    props: ['diapo', 'ii', 'src'],
    data: () => ({
        index: 0
        // src: ''
    }),
    mounted() {
        if (this.ii) {
            this.index = this.ii;
        }
        if (!this.src && this.diapo) {
            if (this.diapo.url) {
                this.src = this.diapo.url;
            } else {
                this.src = `/${this.diapo.dirname}/${this.diapo.basename}`;
            }
        }
    },
    computed: {
        transition() {
            return `slide-${this.$parent.direction}`;
        },
        visible() {
            return this.index === this.$parent.index;
        }
    }
}
</script>

<style>
.slide-right-enter-active {
    animation: slideRightIn .5s;
}

.slide-right-leave-active {
    animation: slideRightOut .5s;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
}

@keyframes slideRightIn {
    from {
        transform: translateX(100%);
    }

    to {
        transform: translateX(0);
    }
}

@keyframes slideRightOut {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-100%);
    }
}

.slide-left-enter-active {
    animation: slideLeftIn .5s;
}

.slide-left-leave-active {
    animation: slideLeftOut .5s;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
}

@keyframes slideLeftIn {
    from {
        transform: translateX(-100%);
    }

    to {
        transform: translateX(0);
    }
}

@keyframes slideLeftOut {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(100%);
    }
}
</style>
